import React from 'react'
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material'

import { HowDidYouHearStepProps } from '../types'

const HowDidYouHearStep: React.FC<HowDidYouHearStepProps> = ({ value, onChange, error }) => {
  const options = ['Friend', 'Social Media', 'Email', 'Other']

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        How did you hear about this event?
      </Typography>

      <FormControl error={error}>
        <RadioGroup value={value} onChange={e => onChange(e.target.value)} className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} className="text-base" />
          ))}
        </RadioGroup>
        {error && <FormHelperText>This question is required</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default HowDidYouHearStep
